import React from 'react';

const Home = () => (
  <section className="home">
    <h2>Welcome to our page!</h2>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit.
      Corrupti enim laborum labore inventore magnam recusandae debitis
      blanditiis dicta! Voluptatum mollitia amet in ullam maxime
      obcaecati magnam esse facilis blanditiis ducimus illum, natus ab
      cupiditate sed recusandae doloremque aperiam vitae impedit dicta
      consectetur. Nemo, exercitationem rem.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur, adipisicing elit. Est
      neque repellat ex quis unde debitis alias exercitationem ipsum
      vitae dolorum. Placeat dolores neque repellat temporibus totam,
      dolorem praesentium quas similique autem distinctio et quae eum
      quo mollitia corporis repellendus laudantium minus earum
      accusantium maxime provident delectus ullam nostrum! Est,
      praesentium?
    </p>
  </section>
);

export default Home;
